export default __webpack_public_path__ + "static/kubecon3-ce03962fec256d412ab751189585067a.webp";